import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import '@/plugins/hotjar'
import vuetify from '@/plugins/vuetify'
import VueMask from 'v-mask'
import HttpClient from '@/servicesTS/HigiaInterceptorService'

import 'higia-lib-components/src/lib-components/assets/scss/styles.scss'

new HttpClient()
Vue.use(VueMask)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app')
